import { Brick, registerBrick } from 'olympe';
import Component from '../../../models/Component';
import Evaluation from '../../../models/Evaluation';
import Inspection from '../../../models/Inspection';
import InspectionEntity from '../../../models/InspectionEntity';
import System from '../../../models/System';

export default class LoadTranslationDetails extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {CloudObject} entity
     * @param {function(Array | QueryResult)} setListOfResult
     * @param {function(string)} setTitle
     * @param {function(boolean)} setLoading
     */
    async update($, [entity], [setListOfResult, setTitle, setLoading]) {
        let result = [];
        let title;
        setLoading(true);

        if (entity instanceof System) {
            title = 'Root Components';
            result = await entity.follow(System.componentsRel).andReturn()
                .sortBy(InspectionEntity.rankProp)
                .follow(InspectionEntity.translatedNameRel).andReturn()
                .execute();
        }
        if (entity instanceof Component) {
            title = 'Sub Components';
            result = await entity.follow(Component.subComponentsRel).andReturn()
                .sortBy(InspectionEntity.rankProp)
                .follow(InspectionEntity.translatedNameRel).andReturn()
                .execute();
            if (result.size() === 0) {
                title = 'Inspections';
                result = await entity.follow(Component.inspectionsRel).andReturn()
                .sortBy(InspectionEntity.rankProp)
                .follow(InspectionEntity.translatedNameRel).andReturn()
                .execute();
            }
        }

        if (entity instanceof Inspection) {
            title = 'Evaluations';
            result = await entity.follow(Inspection.evaluationsListRel).andReturn()
                .follow(Evaluation.translatedNameRel).andReturn()
                .execute();
        }

        setTitle(title);
        setListOfResult(result);
        setLoading(false);
    }
}

registerBrick('018a96c1506180a08972', LoadTranslationDetails);
